<template>
  <div :style="{ position: 'relative' }">
    <Loading :active.sync="loading" :isFullPage="false"></Loading>
    <Card class="p-no-shadow-app">
      <template #title>Localização</template>
      <template #content>
        <div class="p-grid">
          <div class="p-col-12 p-md-3">
            <p><strong>Morada:</strong> {{ localizationInfo?.address }}</p>
            <p>
              <strong>Código Postal:</strong> {{ localizationInfo?.zipCode }}
            </p>
            <p><strong>Localidade:</strong> {{ localizationInfo?.city }}</p>
            <p>
              <strong>Latitude:</strong>
              <InputNumber
                id="latitude"
                name="latitude"
                v-validate="'required'"
                v-model="localizationInfo.latitude"
                :class="[{ 'p-invalid': errors.has('latitude') }, 'p-ml-3']"
                :disabled="!can('changePatLocalization')"
                @input="inputLatLongChanged"
              />
            </p>
            <p>
              <strong>Longitude:</strong>
              <InputNumber
                id="longitude"
                name="longitude"
                v-validate="'required'"
                v-model="localizationInfo.longitude"
                :class="[{ 'p-invalid': errors.has('longitude') }, 'p-ml-1']"
                :disabled="!can('changePatLocalization')"
                @input="inputLatLongChanged"
              />
            </p>
            <p>
              <Button
                v-if="can('changePatLocalization')"
                icon="pi pi-save"
                label="Guardar Localização"
                class="p-button-sm p-button-success"
                @click="saveLocalization()"
              />
            </p>
          </div>
          <div class="p-col-12 p-md-9">
            <div style="height: 500px; width: 100%">
              <LMap
                :zoom="zoom"
                :center="mapCenter"
                :options="mapOptions"
                style="height: 80%"
                ref="PatMap"
                :key="mapID"
                @dblclick="onMapDoubleClick"
              >
                <LTileLayer :url="url" :attribution="attribution" />
                <LMarker :key="patId" :draggable="true" :lat-lng.sync="marker">
                  <LIcon
                    :icon-anchor="staticAnchor"
                    :icon-size="[37, 39]"
                    :icon-url="require('@/assets/map-marker-icon.svg')"
                  >
                  </LIcon>
                </LMarker>
              </LMap>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import PatService from "@/services/pat.service";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import { latLng } from "leaflet";
export default {
  name: "Localization",
  props: {
    patId: {
      type: Number,
      required: true,
    },
  },
  components: {
    Loading,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  data() {
    return {
      loading: false,
      localizationInfo: {},
      mapID: Math.random(),
      zoom: 7,
      marker: latLng(0, 0),
      mapCenter: latLng(0, 0), // Centro de Portugal
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentCenter: null,
      mapOptions: {
        zoomSnap: 0.5,
        doubleClickZoom: false,
      },
      staticAnchor: [16, 37],
    };
  },
  computed: {},
  async created() {
    this.loading = true;
    this.localizationInfo = await PatService.getLocalization(this.patId);
    this.marker = latLng(
      this.localizationInfo.latitude,
      this.localizationInfo.longitude
    );
    this.mapCenter = latLng(
      this.localizationInfo.latitude,
      this.localizationInfo.longitude
    );
    return (this.loading = false);
  },
  methods: {
    inputLatLongChanged() {
      this.marker = latLng(
        this.localizationInfo.latitude,
        this.localizationInfo.longitude
      );
      this.$refs.PatMap.mapObject.panTo(this.marker);
    },
    onMapDoubleClick(event) {
      const { lat, lng } = event.latlng;
      this.marker = latLng(lat, lng);
      this.mapCenter = latLng(lat, lng);
      this.localizationInfo.latitude = lat;
      this.localizationInfo.longitude = lng;
    },
    async saveLocalization() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }

      this.$validator.pause();
      this.$validator.reset();
      let playload = {
        latitude: this.localizationInfo.latitude,
        longitude: this.localizationInfo.longitude,
      };

      await PatService.updateLocalization(this.patId, playload).then(
        (response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Atualizar a Localização`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Localização Atualizada`,
            detail: "",
            life: 3000,
          });
          return this.$emit("updated", response);
        }
      );
    },
  },
};
</script>
<style scoped>
:deep(.leaflet-top.leaflet-left) {
  z-index: 500 !important; /* Valor mais alto */
}
</style>
